import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {InformType} from '../../../../global/util/enum/InformType';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Tsacredential} from '../../../model/Tsacredential';
import {TsaCredentialService} from '../../../service/tsa-credential.service';
import {Constant} from '../../../../global/util/Constant';
import {Tsaprovider} from '../../../model/Tsaprovider';
import {LocalStorage} from '../../../../global/util/LocalStorage';

@Component({
  selector: 'app-add-edit-credential',
  templateUrl: './add-edit-tsa-credential.component.html',
  styleUrls: ['./add-edit-tsa-credential.component.css']
})
export class AddEditTsaCredentialComponent implements OnInit {
  public tsacredential: Tsacredential;
  public loading: boolean;
  public tsaCredentialForm: FormGroup;
  public purpose4Form: number;
  public viewActualPassword: boolean;
  public editPassword: boolean;
  public disableEditPassword: boolean;
  public tsaproviders: Tsaprovider[] = [];
  public readonly DEFAULT_PASSWORD = '************';
  public readonly DEFAULT_PASSWORD_EMPTY = '';
  public readonly DEFAULT_TSA_PROVIDER = 1;

  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private tsaCredentialService: TsaCredentialService) {
    this.createForm();
  }

  ngOnInit() {
    this.loadInitialData();
    switch (this.purpose4Form) {
      case Constant.ADD:
        this.tsacredential.tsaproviderId = this.DEFAULT_TSA_PROVIDER;
        this.tsaCredentialForm.get('password').setValidators(Validators.required);
        this.tsaCredentialForm.get('password').updateValueAndValidity();
        this.editPassword = false;
        this.disableEditPassword = true;
        break;
      case Constant.EDIT:
        this.editPassword = true;
        this.disableEditPassword = false;
        this.tsaCredentialForm.get('password').clearValidators();
        this.tsaCredentialForm.get('password').updateValueAndValidity();
        this.tsacredential.password = this.DEFAULT_PASSWORD;
        break;
    }
  }

  private loadInitialData() {
    this.tsaproviders = LocalStorage.getTsaprovider();
  }

  public save(): void {
    if (this.tsaCredentialForm.invalid) {
      Object.values(this.tsaCredentialForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    this.loading = true;
    if (this.isNewTsacredential) {
      this.register();
    } else {
      this.edit();
    }
  }

  public cancel(): void {
    this.activeModal.close();
  }

  public register() {
    this.tsaCredentialService.save(this.tsacredential).subscribe(tsacredential => {
      this.loading = false;
      this.activeModal.close(InformType.Success);
    }, error => {
      this.loading = false;
      if (error.status === HttpStatusCode.FOUND) {
        this.activeModal.close(InformType.Warning);
      } else {
        this.activeModal.close(InformType.Danger);
      }
    });
  }

  public edit() {
    if (this.DEFAULT_PASSWORD === this.tsacredential.password) {
      this.tsacredential.password = undefined;
    }
    this.tsaCredentialService.edit(this.tsacredential).subscribe(tsacredential => {
      this.loading = false;
      this.activeModal.close(InformType.Success);
    }, error => {
      this.loading = false;
      if (HttpStatusCode.FOUND === error.status) {
        this.activeModal.close(InformType.Warning);
      } else {
        this.activeModal.close(InformType.Danger);
      }
    });
  }

  get isNewTsacredential(): boolean {
    return this.tsacredential.id === undefined;
  }

  private createForm() {
    this.tsaCredentialForm = this.formBuilder.group(
      {
        tsaprovider: ['', [Validators.required]],
        username: ['', [Validators.required]],
        password: [''],
        url: ['', [Validators.required]],
        status: ['']
      });
  }

  public isInvalidControl(ctrlName: string) {
    return this.tsaCredentialForm.get(ctrlName).invalid && this.tsaCredentialForm.get(ctrlName).touched;
  }

  public toggleFieldTextType() {
    this.viewActualPassword = !this.viewActualPassword;
  }

  public disablePasswordControls(event) {
    this.editPassword = !this.editPassword;
    if (event.target.checked) {
      this.tsacredential.password = this.DEFAULT_PASSWORD_EMPTY;
      this.tsaCredentialForm.get('password').setValidators(Validators.required);
      this.tsaCredentialForm.get('password').updateValueAndValidity();
    } else {
      this.tsacredential.password = this.DEFAULT_PASSWORD;
      this.tsaCredentialForm.get('password').clearValidators();
      this.tsaCredentialForm.get('password').updateValueAndValidity();
    }
  }

  get isActive() {
    return String(this.tsacredential.active) === 'true';
  }
}
